<script>
import {api} from "@/modules/api";
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
import {toast} from "vue3-toastify";

export default {
  name: 'BoutonFavorite',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    api() {
      return api
    },
    ...mapStores(useAuthStore),
    isFavorite () {
      if (this.authStore.isConnected) {
        const user = this.authStore.getUser
        const favorite = this.product.Favorite.filter(fav => {
          return fav.userId === user.id
        })
        return favorite[0] ? favorite[0].isLike : false
      }
      return false
    },
  },
  methods: {
    addFavorites () {
      api.profil.updateFavorites(this.product.id).then((res) => {
        this.emitter.emit('load-data', true)
        toast(`Produit ${res.isLike ? 'ajouté à' : 'retiré de' } vos favoris !`)
      })
    }
  }
}
</script>

<template>
  <button v-if="authStore.isConnected" @click="addFavorites" class="flex items-center justify-center py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-100">
    <i v-if="!isFavorite" class="fa-regular fa-heart mr-5"></i>
    <i v-else class="fa-solid fa-heart text-primary-950 mr-5"></i>
    {{ isFavorite ? 'Retirer des' : 'Ajouter aux' }} favoris
  </button>
</template>

